import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SPAPageHeader from '../shared/SPAPageHeader';
import MarkdownViewer from './MarkdownViewer';
import DevDocsSidebar from './DevDocsSidebar';
import type { DocFile } from './devDocs.utils';

interface DevDocsProps {
  basePath?: string;
  files: DocFile[];
}

// AIDEV-NOTE: selectedPath is derived from the URL via react-router useParams('*').
// AIDEV-NOTE: basePath prefixes file navigation so DevDocs works at any mount point.
// Standalone: basePath="" (default) → navigate("/CLAUDE.md")
// DevView:    basePath="/dev-docs" → navigate("/dev-docs/CLAUDE.md")
const DevDocs = ({ basePath = '', files }: DevDocsProps) => {
  const { '*': urlPath } = useParams();
  const navigate = useNavigate();
  const selectedPath = urlPath || 'CLAUDE.md';

  const [searchQuery, setSearchQuery] = useState('');

  const selectedFile = useMemo(
    () => files.find(f => f.path === selectedPath),
    [files, selectedPath],
  );

  const handleSelectFile = (path: string) => {
    navigate(`${basePath}/${path}`);
  };

  return (
    <div className="tw-min-h-screen tw-bg-spa-bg tw-text-spa-on-bg">
      <DevDocsSidebar
        files={files}
        searchQuery={searchQuery}
        selectedPath={selectedPath}
        onSearchChange={setSearchQuery}
        onSelectFile={handleSelectFile}
      />

      <div className="tw-mx-auto tw-max-w-[1400px] tw-px-6 tw-py-4">
        {selectedFile ? (
          <MarkdownViewer content={selectedFile.content} path={selectedPath} />
        ) : (
          <>
            <SPAPageHeader title="DevDocs" />
            <p className="tw-m-0 tw-text-sm tw-text-spa-secondary">File not found.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default DevDocs;
